var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#192949",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4.5C9.5 4.22386 9.72386 4 10 4C10.2761 4 10.5 4.22386 10.5 4.5V12.4446C10.7741 12.3757 11.0333 12.2425 11.2494 12.0448L11.2769 12.019L11.3039 11.9925L13.6462 9.64671C13.8413 9.4513 14.1579 9.45107 14.3533 9.64618C14.5487 9.8413 14.5489 10.1579 14.3538 10.3533L12.0099 12.7007L12.0073 12.7033L12.0073 12.7033L12.0051 12.7054C11.9907 12.7197 11.98 12.7302 11.9689 12.7408C11.958 12.7514 11.947 12.7616 11.9323 12.7753L11.9321 12.7755L11.9298 12.7776L11.9272 12.7801L11.9271 12.7801C10.8672 13.7528 9.17702 13.7383 8.13609 12.7458L5.65497 10.3801C5.45511 10.1895 5.44757 9.87305 5.63813 9.67319C5.82869 9.47333 6.14518 9.4658 6.34503 9.65635L8.82616 12.022C9.0204 12.2072 9.25229 12.3388 9.5 12.4164V4.5ZM4.5 15C4.22386 15 4 15.2239 4 15.5C4 15.7761 4.22386 16 4.5 16H15.5C15.7761 16 16 15.7761 16 15.5C16 15.2239 15.7761 15 15.5 15H4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.f63758bedb66ea58b05045ad0401ddb3.svg";
export { ForwardRef as ReactComponent };